import * as Sentry from "@sentry/react";
import { SENTRY_DSN, isProd } from "./env";

export function initSentry() {
  if (!SENTRY_DSN) {
    console.warn("SENTRY_DSN not configured, skipping Sentry initialization");
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: isProd ? 0.1 : 1.0, // 10% en producción, 100% en desarrollo
    // Session Replay
    replaysSessionSampleRate: isProd ? 0.1 : 1.0, // 10% de sesiones normales
    replaysOnErrorSampleRate: 1.0, // 100% de sesiones con errores
    environment: isProd ? "production" : "development",
  });
}

export { Sentry };
